'use client';

import { useMemo, useState } from 'react';
import { FabricContext } from './contexts/FabricContext';
import { Fabric } from '../utils/interfaces';

export type FabricContextProviderProps = {
  children: React.ReactNode;
  defaultSelectedFabric: Fabric | null;
};

export const FabricContextProvider = ({ children, defaultSelectedFabric }: FabricContextProviderProps) => {
  const [selectedFabric, setSelectedFabric] = useState<Fabric | null>(defaultSelectedFabric);
  const contextValue = useMemo(() => {
    return {
      selectedFabric,
      setSelectedFabric,
    };
  }, [selectedFabric]);

  return <FabricContext.Provider value={contextValue}>{children}</FabricContext.Provider>;
};
